import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import { getCanvas } from './register';
import * as Mixin from './util/mixin';
export var Image = _createClass(function Image() {
  _classCallCheck(this, Image);

  var canvas = getCanvas();
  var image = canvas.createImage && canvas.createImage() || {};

  if (!('tagName' in image)) {
    image.tagName = 'IMG';
    image.__proto__ = Image.prototype;
  }

  Mixin.parentNode(image);
  Mixin.classList(image);
  Object.assign(image, {
    addEventListener: function addEventListener(name, cb) {
      image["on".concat(name)] = cb.bind(image);
    },
    removeEventListener: function removeEventListener(name) {
      image["on".concat(name)] = null;
    }
  });
  return image;
});
//# sourceMappingURL=Image.js.map